export const getPetPhotoPath = (photoUrl) => {
  const legacyPhotoPathMarker = '/api/pet/photo/';
  const markerIndex = typeof photoUrl === 'string' ? photoUrl.indexOf(legacyPhotoPathMarker) : -1;

  return markerIndex === -1 ? null : photoUrl.slice(markerIndex + legacyPhotoPathMarker.length);
};
